import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';


export interface IBatchUpdateKeywordProductMutationFields {
  updatingIds: string[];
  addKeywordClassifications: string[];
  addKeywordBrands: string[];
  addKeywordTags: string[];
  removeKeywordClassifications: string[];
  removeKeywordBrands: string[];
  removeKeywordTags: string[];
  removeAllKeyword: boolean
}


export interface IBatchUpdateKeywordProductMutationResponseFields {
  isSuccess: boolean;
}


export function batchUpdateKeywordProductMutation(fragment: string): DocumentNode {
  return gql`
        mutation batchUpdateKeywordProduct (
        $updatingIds: [String]!,
$addKeywordClassifications: [String]!,
$addKeywordBrands: [String]!,
$addKeywordTags: [String]!,
$removeKeywordClassifications: [String]!,
$removeKeywordBrands: [String]!,
$removeKeywordTags: [String]!,
$removeAllKeyword: Boolean!
        ) {
        batchUpdateKeywordProduct (
        updatingIds: $updatingIds,
addKeywordClassifications: $addKeywordClassifications,
addKeywordBrands: $addKeywordBrands,
addKeywordTags: $addKeywordTags,
removeKeywordClassifications: $removeKeywordClassifications,
removeKeywordBrands: $removeKeywordBrands,
removeKeywordTags: $removeKeywordTags,
removeAllKeyword: $removeAllKeyword
        ) {
        ...fragment
        }
        }
        fragment fragment on BatchUpdateKeywordProductMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useBatchUpdateKeywordProductMutation<TData extends Partial<IBatchUpdateKeywordProductMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ batchUpdateKeywordProduct: TData },
        IBatchUpdateKeywordProductMutationFields>,
) {
  return useMutation<{ batchUpdateKeywordProduct: TData },
      IBatchUpdateKeywordProductMutationFields>(
        batchUpdateKeywordProductMutation(fragment), options,
      );
}
